import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

function RequireAdmin({ children }: { children: React.ReactNode }) {
    const [status, setStatus] = useState<'checking' | 'ok' | 'unauthorized'>('checking')

    useEffect(() => {
        fetch('/api/admin/session')
            .then(r => {
                setStatus(r.ok ? 'ok' : 'unauthorized')
            })
            .catch(() => setStatus('unauthorized'))
    }, [])

    if (status === 'checking') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <span className="w-8 h-8 border-4 border-yubico-green-400 border-t-transparent rounded-full animate-spin" />
            </div>
        )
    }

    if (status === 'unauthorized') {
        return <Navigate to="/admin/login" replace />
    }

    return <>{children}</>
}

export default RequireAdmin
